import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

export default function CopyButton({ text, label, className = 'btn btn-subtle btn-sm' }) {
  const { t } = useTranslation();
  const [done, setDone] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (_) {
      const ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (_) {}
      document.body.removeChild(ta);
    }
    setDone(true);
    setTimeout(() => setDone(false), 1600);
  };

  return (
    <button type="button" className={className} onClick={copy}>
      <Icon name={done ? 'check' : 'copy'} size={13} />
      {done ? t('common.copied') : label || t('onboarding.copy')}
    </button>
  );
}
